// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Filter: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 25 24"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M0 18.8v2.4H3.906V24H11.72v-2.8H25v-2.4H11.718V16H3.907v2.8H0zm0-8v2.4h13.282V16H21.093v-2.8H25v-2.4H21.094V8H13.28v2.8H0zm5.469-5.6V8H13.28V5.2H25V2.8H13.281V0H5.47v2.8H0v2.4H5.469zm10.156 8.4v-3.2h3.125v3.2h-3.125zM6.25 18.4h3.125v3.2H6.25v-3.2zM7.813 5.6V2.4h3.125v3.2H7.812z" />
        </svg>
    );
};

export default React.memo(Filter);
